import Component from '@glimmer/component';
import styles from './navigation-bar.module.scss';

export default class NavigationBar extends Component {
  styles = styles;
}
